import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal } from "react-router-modal";
import { Link } from "react-router-dom";
import { Translate } from "react-localize-redux";

class IntroModal extends Component {
  render() {
    if (!!this.props.isOpen) {
      return (
        <Modal>
          <h2>
            <Translate id={this.props.introTitle} />
          </h2>
          <p>
            <span>
              <Translate id={this.props.introParagraph} />
            </span>
            {!!this.props.introParagraphLink && (
              <Link
                to={{
                  pathname: this.props.introParagraphLink,
                  search: this.props.location.search
                }}
              >
                <em>
                  <Translate id={this.props.introParagraphLinkLabel} />
                </em>
              </Link>
            )}
            <span>
              {this.props.introParagraphExtra ? (
                <Translate id={this.props.introParagraphExtra} />
              ) : (
                undefined
              )}
            </span>
          </p>
          {!!this.props.externalLink && (
            <div>
              <a
                className="tooltip-text-link"
                href={window.public_url + this.props.externalLink}
                target="_blank"
              >
                <Translate id={this.props.externalLinkLabel} />{" "}
                <i className="fa fa-external-link" aria-hidden="true" />
              </a>
            </div>
          )}
          <button
            className="fill-next-button"
            onClick={this.props.closeModal}
            type="button"
          >
            <Translate id="introModalGetStarted" />
          </button>
        </Modal>
      );
    } else {
      return null;
    }
  }
}

IntroModal.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: () => {},
  introTitle: PropTypes.string,
  introParagraph: PropTypes.string,
  introParagraphExtra: PropTypes.string,
  introParagraphLink: PropTypes.string,
  introParagraphLinkLabel: PropTypes.string,
  externalLink: PropTypes.string,
  externalLinkLabel: PropTypes.string
};

IntroModal.defaultProps = {
  isOpen: true,
  introTitle: "",
  introParagraph: "",
  introParagraphExtra: "",
  introParagraphLink: null,
  introParagraphLinkLabel: "",
  externalLink: null,
  externalLinkLabel: ""
};

export default IntroModal;



// WEBPACK FOOTER //
// ./src/components/IntroModal.jsx